import React from 'react';
import { Form, Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { ConfirmationModal } from '../Modals';
import { getMetaAppointmentsQuery } from '../../schemas/getMetaAppointments';
import { useTranslation } from 'react-i18next';

interface RescheduleReasonConfirmModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

const RescheduleReasonConfirmModal: React.FC<RescheduleReasonConfirmModalProps> = ({ open, onCancel, onConfirm }) => {
  const { t } = useTranslation('common');
  const [form] = Form.useForm();
  const { data: meta } = useQuery(getMetaAppointmentsQuery());
  const rescheduleReasons = meta?.appt_reschedule_reasons ?? [];
  const selectedReason = Form.useWatch('reason', form);

  const handleOk = () => {
    const reason = form.getFieldValue('reason');
    if (reason) {
      onConfirm(reason);
      form.resetFields();
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <ConfirmationModal
      open={open}
      onCancel={handleCancel}
      okText={t('Reschedule')}
      okButtonProps={{ disabled: !selectedReason }}
      onOk={handleOk}
      title={t('Please select a reason why you wish to reschedule the appointment')}
    >
      <Form form={form} layout="vertical">
        <Form.Item label={t('Reason for rescheduling')} name="reason" rules={[{ required: true }]}>
          <Select
            options={rescheduleReasons?.map(({ appt_reschedule_desc: label, appt_reschedule_code: value }) => ({
              label,
              value
            }))}
            placeholder={t('Select from dropdown')}
            data-testid="reschedule-reason-select"
          />
        </Form.Item>
      </Form>
    </ConfirmationModal>
  );
};

export { RescheduleReasonConfirmModal };
